import { useEffect } from 'react'
import { batch } from 'react-redux'

import { ERROR_PAGE_PATH } from '../constants'
import { fetchBootstrap } from '../features/appConfig/appConfigSlice'
import { fetchCartItems, getAccessGuarantee } from '../features/cart/cartSlice'
import { fetchProducts } from '../features/products/productSlice'
import { useAppDispatch, useAppSelector } from '../store'

export const useLoadPayload = (): void => {
  const dispatch = useAppDispatch()
  const { isSuccess: isProductSuccess } = useAppSelector((state) => state.productReducer)
  const { isBootstrapLoaded, isBootstrapLatest, isBootstrapLoading } = useAppSelector((state) => state.appConfigReducer)

  useEffect(() => {
    // prevent loading bootstrap payload when on `/error` since the issue that might have led to that page is with the api.
    if (isBootstrapLoading || window.location.pathname === ERROR_PAGE_PATH) return
    if (!isBootstrapLatest) dispatch(fetchBootstrap())
  }, [dispatch, isBootstrapLatest, isBootstrapLoaded, isBootstrapLoading])

  useEffect(() => {
    if (isBootstrapLoading || !isBootstrapLatest) return
    if (isBootstrapLatest) dispatch(fetchProducts())
  }, [dispatch, isBootstrapLatest, isBootstrapLoading])

  useEffect(() => {
    if (!isBootstrapLoaded || !isBootstrapLatest || !isProductSuccess) return
    batch(() => {
      dispatch(fetchCartItems())
      dispatch(getAccessGuarantee())
    })
  }, [dispatch, isBootstrapLatest, isBootstrapLoaded, isProductSuccess])
}
